import typography from '../typography';

export default {
  root: {
    ...typography.subtitle3,
    paddingTop: 4,
    paddingBottom: 1,
  },
};
